import { IPlayer } from './index';
import { Observer } from './Observer';

interface ITypePropertyCollection {
  [key: string]: Property;
}

export class PropertyHolder {
  public static initialize(holder: IPlayer) {
    if (
      holder &&
      typeof holder.get === 'function' &&
      typeof holder.set === 'function' &&
      typeof holder.registerProperty === 'function' &&
      typeof holder.reset === 'function'
    ) {
      PropertyHolder._holder = holder;
    }
  }

  public static set(name: string, value: any) {
    if (PropertyHolder._holder) {
      PropertyHolder._holder.set(name, value);
    } else {
      if (!PropertyHolder._properties[name]) {
        PropertyHolder._properties[name] = new Property(name);
      }
      PropertyHolder._properties[name].value = value;
    }
  }

  public static get(name: string): any {
    let result: any;
    if (PropertyHolder._holder) {
      result = PropertyHolder._holder.get(name);
    } else {
      if (PropertyHolder._properties[name]) {
        result = PropertyHolder._properties[name].value;
      }
    }
    return result;
  }

  public static registerProperty(
    name: string,
    defaultValue: any,
    nonResetable?: boolean,
  ) {
    if (PropertyHolder._holder) {
      PropertyHolder._holder.registerProperty(name, defaultValue, nonResetable);
    } else {
      if (!PropertyHolder._properties[name]) {
        PropertyHolder._properties[name] = new Property(name, defaultValue);
      } else {
        PropertyHolder._properties[name].defaultValue = defaultValue;
      }
    }
  }

  public static reset(name: string) {
    if (PropertyHolder._holder) {
      PropertyHolder._holder.reset();
    } else {
      if (PropertyHolder._properties[name]) {
        PropertyHolder._properties[name].reset();
      }
    }
  }

  public static getPropertyObject(name: string): Property | null {
    return PropertyHolder._properties[name]
      ? PropertyHolder._properties[name]
      : null;
  }
  private static _properties: ITypePropertyCollection = {};
  private static _holder: IPlayer;
}

// tslint:disable-next-line: max-classes-per-file
export class Property {
  private _name: string;
  private _currentValue: any;
  private _defaultValue: any;

  constructor(name: string, defaultValue?: any) {
    this._name = name;
    this._defaultValue = defaultValue;
    this._currentValue = defaultValue;
    if (defaultValue) {
      this.sendValueChangedEvent();
    }
  }

  public reset() {
    this.value = this._defaultValue;
  }

  public set value(value: any) {
    this._currentValue = value;
    this.sendValueChangedEvent();
  }

  public get value(): any {
    return this._currentValue;
  }

  public get name(): string {
    return this._name;
  }

  public set defaultValue(value: any) {
    this._defaultValue = value;
  }

  private sendValueChangedEvent() {
    const eventName = 'property:' + this._name;
    Observer.emit(eventName, this._currentValue);
  }
}
